import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { DadosPixSucesso } from "../../../../types/mutations/financeiro/emitir-pix";
import PaperDraggable from "../../../PaperDraggable";
import { formatarValorMonetario } from "../../../../helpers/masks";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";

export default function DialogPixSucesso({
  data,
  open,
  onClose,
}: DialogPixSucessoProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
    >
      <CheckCircleOutlinedIcon
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          fontSize: "60px",
          marginTop: "1rem",
        }}
        color="success"
      />
      <DialogTitle id="draggable-dialog-title" align="center">
        <b>Transação Pix realizada</b>
        <Typography variant="body2" gutterBottom align="center">
          {data.data}, {data.hora}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Typography variant="body2">
              <b>Valor</b>
            </Typography>
            {data.recibos.map((recibo, index) => (
              <Typography key={index} variant="body2">
                {formatarValorMonetario(recibo.valor)}
              </Typography>
            ))}
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <Typography variant="body2">
              <b>Realizado por</b>
            </Typography>
            <Typography variant="body2">{data.recebido_por}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogPixSucessoProps {
  data: DadosPixSucesso;
  open: boolean;
  onClose: () => void;
}
